import he from "he";

export function decodeHtmlEntitiesPasteValue(element: HTMLElement) {
  element.onpaste = (e) => {
    e.preventDefault();
    let text;
    const clp = e.clipboardData;
    if (clp) {
      text = clp.getData("text/plain") || "";
      if (text != "") {
        text = he.decode(text);
        document.execCommand("insertText", false, text);
      }
    }
  };
}

/*

 let text;
    const clp = (e.originalEvent || e).clipboardData;
    if (clp == null) {
      text = window.clipboardData?.getData("text") || "";
      if (text !== "") {
        text = he.decode(text);
        if (window.getSelection) {
          const newNode = document.createElement("span");
          newNode.innerHTML = text;
          window.getSelection().getRangeAt(0).insertNode(newNode);
        } else {
          document.selection.createRange().pasteHTML(text);
        }
      }
    } else {
      text = clp.getData("text/plain") || "";
      if (text !== "") {
        text = he.decode(text);
        document.execCommand("insertText", false, text);
      }
    }
 */
